import { Controller } from 'stimulus';
import getControllerForElement from '../helpers/getControllerForElement';
import { serialize } from './attribution-controller';

class ExternalLinkConversionData extends Controller {
  connect() {
    getControllerForElement(this.application, document.documentElement, 'attribution')
      .then((controller) => {
        // Request the last attribution data from localstorage
        const lastAttribution = controller.lastAttribution();

        if (lastAttribution) {
          const firstAttributionCharacterization = controller.firstAttributionCharacterization();
          const lastAttributionCharacterization = controller.lastAttributionCharacterization();

          // Transform attribution data into a query string
          const query = controller.attributionObjectToQueryString({
            ...lastAttribution,
            first_attribution: firstAttributionCharacterization,
            last_attribution: lastAttributionCharacterization,
          });

          if (query) {
            this.enrichExternalLinks(query);
            this.enrichCalendlyLinks(lastAttribution, lastAttributionCharacterization);
          }
        }
      });
  }

  // eslint-disable-next-line class-methods-use-this
  enrichExternalLinks(query) {
    // Retrieve all links on the page
    const links = Array.prototype.slice.call(document.querySelectorAll('a'));

    // Filter down links to only links to app.routelogic.io
    const appRoutelogicLinks = links.filter((link) => (
      link.href.indexOf('app.routelogic.io') >= 0
    ));

    // Add the query parameters to every app.routelogic.io link.
    appRoutelogicLinks.forEach((link) => {
      let href = link.getAttribute('href');

      href += `${(href.indexOf('?') >= 0 ? '&' : '?')}${query}`;

      link.setAttribute('href', href);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  enrichCalendlyLinks(lastAttribution, lastAttributionCharacterization) {
    // Retrieve all links on the page
    const links = Array.prototype.slice.call(document.querySelectorAll('a'));

    // Filter down links to only links to calendly.com
    const calendlyLinks = links.filter((link) => (
      link.href.indexOf('calendly.com') >= 0
    ));

    calendlyLinks.forEach((calendlyLink) => {
      let href = calendlyLink.getAttribute('href');

      const query = serialize({
        utm_source: lastAttributionCharacterization,
        utm_content: typeof lastAttribution.gclid !== 'undefined' ? lastAttribution.gclid : '',
      });

      href += `${(href.indexOf('?') >= 0 ? '&' : '?')}${query}`;

      calendlyLink.setAttribute('href', href);
    });
  }
}

export default ExternalLinkConversionData;
